export default __webpack_public_path__ + "static/media/Kakao-Normal.6abecb4c.png";